// styles
import { chartDashboardBoxStyle } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledManpowerCard = styled.div`
  ${chartDashboardBoxStyle}

  > h2 {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const StyledGraphWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  margin-bottom: 28px;

  > canvas {
    position: relative;
    height: 400px !important;
  }
`;
